import React from "react";

const FoundHerPurpose = () => {
  return (
    <section className="py-4 px-4 bg-gradient-to-b from-[#2b1026] via-[#3a1236] to-[#2a1031]">
      <div className="max-w-5xl mx-auto text-center">
        <div className="uppercase tracking-[0.25em] text-pink-300 font-semibold mb-4">
          💜 WHY FOUNDHER EXISTS
        </div>

        <h2 className="text-xl lg:text-2xl font-black text-white leading-tight mb-4">
          Great ideas shouldn't remain invisible simply because
          young women lack access, guidance, or opportunities.
        </h2>

        <p className="max-w-3xl mx-auto text-sm lg:text-lg text-rose-200 leading-relaxed mb-4">
          FoundHer exists to help the next generation of women entrepreneurs
          discover their purpose, launch meaningful ventures, connect with
          customers, access mentors, receive community support, and build
          sustainable businesses with confidence.
        </p>

        <div className="grid md:grid-cols-3 gap-5 text-left">
          {[
            {
              emoji: "🌱",
              title: "Purpose First",
              desc: "Every entrepreneur begins by discovering her purpose through Think5Whys before building a venture."
            },
            {
              emoji: "🚀",
              title: "Growth Together",
              desc: "Learn, launch, sell, collaborate, and grow with mentors, supporters, customers, and fellow founders. Think5Whys is ofefring its inbuild digital commerce ecosystem to support her."
            },
            {
              emoji: "💜",
              title: "Community Powered",
              desc: "A supportive ecosystem where buying, mentoring, volunteering, sponsorship, and collaboration help every founder succeed."
            }
          ].map((item, index) => (
            <div
              key={index}
              className="rounded-3xl border border-pink-400/20 bg-white/5 backdrop-blur-md px-6 py-2 hover:bg-white/10 transition-all duration-300"
            >
              <div className="text-lg lg:text-xl mb-2">{item.emoji}</div>
              <h3 className="text-sm lg:text-lg font-bold text-white mb-2">
                {item.title}
              </h3>
              <p className="text-rose-200 text-xs lg:text-sm leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FoundHerPurpose;